module.exports = __webpack_public_path__ + "static/media/elmadmin.396fa855.png";